import { useTranslation } from "react-i18next";
import type { Session } from "../../../../../store/admin/sessionsStore";
import { DENSE_LIST, type ThemeClasses } from "../../../shared";
import SessionRow from "./SessionRow";

interface SessionsTableProps {
  themeClasses: ThemeClasses;
  sessions: Session[];
  loading: boolean;
  error: string | null;
  onViewSession: (session: Session) => void;
  onLogoutSession: (session: Session) => void;
}

export default function SessionsTable({
  themeClasses,
  sessions,
  loading,
  error,
  onViewSession,
  onLogoutSession,
}: SessionsTableProps) {
  const { t } = useTranslation("adminSections");

  if (loading) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="flex flex-col items-center">
          <i className="ri-loader-4-line animate-spin text-3xl text-primary-500 mb-3"></i>
          <p className="text-gray-500">{t("sessions.loading")}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center py-16">
        <div className="flex flex-col items-center">
          <i className="ri-error-warning-line text-3xl text-red-500 mb-3"></i>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <i
          className={`ri-computer-line text-5xl ${themeClasses.textSecondary} mb-4`}
        ></i>
        <h3 className={`text-lg font-medium ${themeClasses.text} mb-2`}>
          {t("sessions.noSessions")}
        </h3>
        <p className={`${themeClasses.textSecondary} text-sm`}>
          {t("sessions.noSessionsDescription")}
        </p>
      </div>
    );
  }

  return (
    <div className={DENSE_LIST}>
      {sessions.map((session) => (
        <SessionRow
          key={session.id}
          session={session}
          themeClasses={themeClasses}
          onView={() => onViewSession(session)}
          onLogout={() => onLogoutSession(session)}
        />
      ))}
    </div>
  );
}
